<template>
  <div style="background-color:white !important;height:100vh;">
    <div style="padding: 200px 20px 20px 20px; margin: 0 auto; max-width: 800px">
      <div class="row">
        <div class="col-md-6">
          <p style="padding-top:60px;font-size:25px">¡Tenemos nuevo portal!</p>
          <p style="font-size:16px">
            Estimados clientes, nos emociona anunciar el lanzamiento de nuestro nuevo portal web. 
            <br><br>
            Mantuvimos la experiencia de uso que tanto aprecian, con un portal más rápido y eficiente diseñado para mejorar su navegación.
            <br><br>
            Saludos cordiales, Equipo de Prevn.
          </p>
        </div>
        <div class="col-md-6">
          <div class="ibox-content" style="border-color: white">
            <form @submit.prevent="handleSubmit">
              <div>
                  <img width="300" style="padding: 20px;display: block;margin-left: auto;margin-right: auto;" src="../../assets/logo.png">
              </div>
              <div class="form-group">
                  <input type="email" v-model="correo" class="form-control" placeholder="Correo" required="true">
              </div>
              <div class="form-group">
                  <input type="password" v-model="pass" class="form-control" placeholder="Contraseña" required="true" >
              </div>
              <div class="form-group" style="text-align: center">
                  <a href="javascript:void(0)" style="color:#f0ad4e" v-on:click="modal_recuperar_pass">
                      <small>Recuperar contraseña</small>
                  </a>
              </div>
              <b-button v-if="!loading" variant="primary" v-on:click="handleSubmit" style="margin-top: 20px; width:100%">Iniciar sesión</b-button>
              <b-button v-else variant="primary" style="margin-top: 20px; width:100%"><Loading :size="'1'" :text="'Iniciando sesión'"/></b-button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <b-modal hide-footer ref="modal_pass" title="Ingrese su correo para iniciar el proceso de recuperación">
      <div class="form-group">
          <label>Correo</label>
          <input type="email" v-model="correo_recuperacion" class="form-control" required="true">
      </div>
      <b-button v-if="!loading_correo_recuperacion" variant="primary" style="width:100%" v-on:click="recuperar_pass">Recuperar contraseña</b-button>
      <b-button v-else variant="primary" style="margin-top: 20px; width:100%"><Loading :size="'1'" :text="'Enviando correo de recuperación'"/></b-button>
    </b-modal>
  </div>
</template>

<script>

import {userService} from "@/services";
import {utils} from "@/helpers";

export default {
  data() {
    return {
      correo:'',
      pass:'',
      loading:false,
      correo_recuperacion:'',
      loading_correo_recuperacion:false
    }
  },
  methods : {
    handleSubmit : function(){
      let correo = this.correo;
      let pass = this.pass;

      if(correo && pass){
        this.loading = true;

        userService.login(correo, pass)
          .then(respuesta => {
            if(respuesta.status == "success"){
              //home
              this.$router.push("/home");
            }else{
              utils.alerta(respuesta);
            }
            this.loading = false;
          });
      }
    },
    modal_recuperar_pass : function(){
      this.$refs['modal_pass'].show()
    },
    recuperar_pass : function(){
      if(this.correo_recuperacion){
        this.loading_correo_recuperacion = true;

        userService.recuperarPassUsuario({
          'correo':this.correo_recuperacion,
        }).then(respuesta => {
          utils.alerta(respuesta);
          this.loading_correo_recuperacion = false;

          if(respuesta.status == 'success'){
            this.$refs['modal_pass'].hide()
          }
        });
      }else{
        utils.alerta({'msg':'Debe ingresar un correo','status':'warning'});
      }
    }
  }
}
</script>

<style scoped>
</style>
